/**
 * Portal content width: most pages use the ~1180px centered shell;
 * data-heavy table/canvas routes use full width.
 */

const FULL_WIDTH_PREFIXES = [
  // Agency
  '/agency/kols',
  '/agency/jobs',
  '/agency/campaigns',
  '/agency/messaging-log',
  '/agency/invitations',
  '/agency/submissions',
  '/agency/kol-performance',
  '/agency/brands',
  '/agency/team',
  '/agency/contracts',
  '/agency/ai-credits',
  '/agency/payments-analytics',
  '/agency/kol-data-tools',
  '/agency/api-docs',
  '/agency/whatsapp-canvas',
  // Brand
  '/brand/jobs',
  '/brand/kols',
  '/brand/submissions',
  '/brand/contracts',
  '/brand/team',
  '/brand/payments',
  '/brand/analytics',
  // KOL
  '/kol/invitations',
  '/kol/earnings',
  // Admin
  '/admin/dashboard',
  '/admin/users',
  '/admin/kols',
  '/admin/campaigns',
  '/admin/payments',
  '/admin/agencies',
  '/admin/brands',
  '/admin/ai-credits',
] as const;

/** Edge-to-edge bleed (no content padding) — canvases / immersive tools. */
const BLEED_PREFIXES = ['/agency/whatsapp-canvas'] as const;

function matchesPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isPortalContentFullWidth(pathname: string): boolean {
  if (pathname === '/admin' || pathname === '/admin/') return true;
  return FULL_WIDTH_PREFIXES.some((p) => matchesPrefix(pathname, p));
}

export function isPortalContentBleed(pathname: string): boolean {
  return BLEED_PREFIXES.some((p) => matchesPrefix(pathname, p));
}

export function portalContentClassName(pathname: string): string {
  const parts = ['portal-content'];
  if (isPortalContentFullWidth(pathname)) parts.push('portal-content-full');
  if (isPortalContentBleed(pathname)) parts.push('portal-content-bleed');
  return parts.join(' ');
}

/** Scroll/main area wrapper — bleed pages fill height instead of scrolling the shell. */
export function portalMainClassName(pathname: string): string {
  if (isPortalContentBleed(pathname)) {
    return 'flex-1 min-h-0 overflow-hidden flex flex-col glass-scroll';
  }
  return 'flex-1 overflow-auto glass-scroll';
}
